<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-brand class="router-link" to="/home" ><b-icon-chat-right-fill></b-icon-chat-right-fill>&nbsp;{{ settings.applicationname }}</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item-dropdown :text="'My ' + settings.appraisal">
                    <b-dropdown-item class="router-link" to="/create" ><b-icon-plus></b-icon-plus>&nbsp;Create {{ settings.appraisal }}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item class="router-link" to="/view" ><b-icon-card-heading></b-icon-card-heading>&nbsp;View {{ settings.appraisal }}</b-dropdown-item>
                    <b-dropdown-item class="router-link" to="/list" ><b-icon-list-ul></b-icon-list-ul>&nbsp;View All {{ settings.appraisal }}s</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex'

    export default {
        
        computed: {
            ...mapGetters([
                'settings',
            ]),
        },
    }
</script>